<div>

  <div class="flex justify-content-center gap-2 mb-3 align-items-center">
    <p-button 
      label="Drafts" 
      [outlined]="selectedSection !== 'drafts'" 
      [severity]="selectedSection === 'drafts' ? 'primary' : undefined"
      (click)="selectSection('drafts')">
    </p-button>

    <p-button 
      label="Inbox" 
      [outlined]="selectedSection !== 'inbox'" 
      [severity]="selectedSection === 'inbox' ? 'primary' : undefined"
      (click)="selectSection('inbox')">
    </p-button>

    <p-button 
      label="Sent" 
      [outlined]="selectedSection !== 'sent'" 
      [severity]="selectedSection === 'sent' ? 'primary' : undefined"
      (click)="selectSection('sent')">
    </p-button>

    <div style="border-left: 1px solid var(--surface-border); height: 1.5rem; margin: 0 0.5rem;"></div>

    <p-button 
      icon="pi pi-plus" 
      label="New Email" 
      [text]="true" 
      (onClick)="newEmailDialogVisible = true; newDraftEmail()">
    </p-button>
    <p-dialog [(visible)]="newEmailDialogVisible" appendTo="body" [style]="{width: '50vw', height:'75vh'}" styleClass="overflow-y-scroll" (onHide)="cancelEmail()">
      <app-email-composer *ngIf="draftEmail" [emailHandler]="emailHandler" [draftEmail]="draftEmail" (sendEmail)="sendEmail($event)" (cancelEmail)="newEmailDialogVisible = false; cancelEmail();" (draftSaved)="newEmailDialogVisible=false; draftSaved();"></app-email-composer>
    </p-dialog>
  </div>

  <div *ngIf="selectedSection === 'drafts'">
    <p-overlayPanel #draftEditor appendTo="body" #emailEditor styleClass="overflow-y-scroll" (onHide)="editorClosed()">
      <app-email-composer 
        *ngIf="selectedDraft" 
        [emailHandler]="emailHandler" 
        [draftEmail]="selectedDraft"
        (sendEmail)="draftEditor.hide(); sendDraft($event)" 
        (cancelEmail)="draftEditor.hide(); editorClosed();" 
        (draftSaved)="draftEditor.hide(); editorClosed();">
      </app-email-composer>
    </p-overlayPanel>
    <p-panel header="Encounter">
      <p-table [value]="encounterDraftEmailItems || []" [paginator]="true" sortMode="single" [rows]="5">
        <ng-template pTemplate="header">
          <tr>
            <th>Last Saved Date</th>
            <th>Recipient</th>
            <th>Subject</th>
            <th></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-email>
          <tr> 
            <ng-container *ngIf="email.getDraftEmail() as draft">
              <td>{{ draft.dateLastSaved | date: 'short' }}</td>
              <td>
                <p-tag *ngFor="let r of draft.recipients" icon="pi pi-user" [rounded]="true" [value]="r"></p-tag>
              </td>
              <td>{{ draft.subject }}</td>
              <td>
                <p-button icon="pi pi-pencil" label="Edit" [text]="true" (onClick)="openEditor(email, $event)"></p-button>
              </td>
              <td>
                <p-button label="Delete" severity="danger" (onClick)="deleteButtonPressed($event, draft.id, draft.draftType)"></p-button>    
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>

  <div *ngIf="selectedSection === 'inbox'">
    <app-received-email-list
      [emails]="receivedEmails || []"
      (emailViewed)="emailViewed($event)">
    </app-received-email-list>
  </div>

  <div *ngIf="selectedSection === 'sent'">
    <app-sent-email-list [emailHandler]="emailHandler" [emails]="sentEmails" [showSend]="false"></app-sent-email-list>
  </div>
</div>
